import React from 'react';
import {
  Box,
  Container,
  Flex,
  Text,
  VStack,
  useBreakpointValue,
  Image,
} from '@chakra-ui/react';
import LoginImage from '../media/images/LoginImage.svg';
import SpotOnIcon from '../media/images/SpotOnIcon.svg';
import NraRegisterContent from '../components/register/NraRegisterContent';

const NraRegister = () => {
  const isDesktop = useBreakpointValue({ base: false, lg: true });
  const projectName = 'Profit Assist';

  return (
    <Box minH="100vh" bg="gray.50">
      <Container maxW="container.xxl" px={4}>
        <Flex
          minH="100vh"
          align="center"
          justify="center"
          direction={{ base: 'column', lg: 'row' }}
        >
          {isDesktop && (
            <Box
              flex="1"
              maxW="800px"
              h="100vh"
              position="relative"
              overflow="hidden"
            >
              <Image
                src={LoginImage}
                alt="Login Image"
                objectFit="cover"
                w="100%"
                h="100%"
              />
            </Box>
          )}

          <Box
            flex="1"
            maxW={{ base: '100%', lg: '800px' }}
            w="full"
            bg="white"
            rounded="xl"
            boxShadow="xl"
            h="100vh"
            display="flex"
            alignItems="center"
          >
            <VStack
              h="100vh"
              w="100%"
              align="stretch"
              justify="flex-start"
              bg="gray.50"
              flexDirection="column"
              spacing="25%"
            >
              <Flex alignSelf="flex-start" ml={8} mt={8}>
                <Image src={SpotOnIcon} alt="SpotOn Logo" w="20px" mr={3} />
                <Text fontWeight={'600'} fontSize={'16px'}>
                  {projectName}
                </Text>
              </Flex>

              <Flex justifyContent="center" alignItems="center" w="100%">
                <NraRegisterContent />
              </Flex>
            </VStack>
          </Box>
        </Flex>
      </Container>
    </Box>
  );
};

export default NraRegister;
